<template>
  <div class="p-lg">
    <h2 class="m-b-lg">{{ $t('configurator.chooseTourLong') }}</h2>
    <form>
      <div role="fieldset" class="flex products-container">
        <!--Todo: Consider outsource this into an own component like in extras -->
        <div class="product" v-for="product in products" :key="product.id">
          <card clickable class="card">
            <styled-circle-button
              @click.prevent="
                toggleModal({
                  title: product.Title,
                  description: product.Description,
                  teaserImage: product.TeaserImage,
                })
              "
              class="label-info"
            >
              <icon name="info" />
            </styled-circle-button>
            <input
              type="radio"
              name="product"
              :id="product.id"
              :value="product.Title"
              tabindex="0"
              @click="product.bookable ? $emit('product-selected', product.id) : false"
              @keyup.enter="$emit('product-selected', product.id)"
              class="input-product"
            />
            <label
              :for="product._id"
              class="p-lg block pointer"
              :style="product.bookable ? '' : 'filter: grayscale(100%);'"
            >
              <img
                :src="product.Icon ? product.Icon.url : fallbackIcon"
                class="m-b-lg label-image align-center block"
                :alt="product.Title"
              />
              <span class="label-product -big">{{ product.Title }}</span>
              <span class="p-t-xs label-product">
                {{ getPrice(product.Price) }}
                {{ $t('configurator.perPersonShort') }}
              </span>
            </label>
            <div v-if="!product.bookable" class="bookable-text">
              {{ product.bookableText }}
            </div>
          </card>
        </div>
      </div>
    </form>
    <modal class="modal" v-if="modalOpen" @close="toggleModal({})">
      <card class>
        <div
          class="modal-teaser"
          :style="
            `background-image: url(${modalContent.teaserImage ? modalContent.teaserImage.url : ''}`
          "
        >
          <H2 class="p-l-xl p-b-md" font-family="Bitter" color="#ffffff" size="2rem">{{
            modalContent.title
          }}</H2>
        </div>
        <div class="p-b-xl p-l-xl p-r-xl html-content" v-html="modalContent.description" />
      </card>
    </modal>
  </div>
</template>
<script>
import icon from 'vue-awesome/components/Icon';
import card from '@/components/common/card';
import modal from '@/components/modal.vue';
import fallbackIcon from '@/assets/images/fallback_icon.png';
import styledCircleButton from '@/components/common/styledCircleButton';
import Currency from '@/utils/currency';
import { H2 } from '@/components/common/styledHeading';

export default {
  name: 'product-selection',

  components: {
    card,
    icon,
    modal,
    styledCircleButton,
    H2,
  },

  props: {
    products: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      fallbackIcon,
      modalOpen: false,
      modalContent: {},
    };
  },

  methods: {
    getPrice(price) {
      return Currency.floatToEuro(price);
    },

    /**
     * Changes modal state to its opposite and content for product details.
     * @param {String} modalContent - The content for the modal
     */
    toggleModal(modalContent) {
      this.modalContent = modalContent;
      this.modalOpen = !this.modalOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
.products-container {
  margin: 0 -1rem;
}

.card {
  position: relative;
}

.product {
  width: calc(100% / 2);
  padding: 1rem;
  min-height: 15rem;

  @media screen and (min-width: 35rem) {
    width: calc(100% / 6);
  }
}

.input-product {
  opacity: 0;
  &:focus {
    opacity: 1;
  }
}

.label-info {
  float: right;
  margin: 0.5rem;
}

.label-image {
  object-fit: contain;
  height: 70%;
  max-height: 7rem;
  width: 100%;
}

.label-product {
  display: inline-block;
  width: 100%;
  text-align: center;

  &.-big {
    font-weight: 700;
    min-height: 2.25rem;
  }

  &.-fine {
    font-weight: 100;
  }
}

.bookable-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgb(200, 0, 0);
  color: #fff;
  padding: 1rem 0.5rem;
  text-align: center;
}

.modal-teaser {
  position: relative;
  width: 100%;
  padding-top: 10rem;
  background-size: cover;
  background-position: center center;
}
</style>
